.empty-table{margin-bottom:3em}.outcome-submitted .outcome.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=pregnancy-outcome-add-edit.component-T3E5T45H.css.map */
